import { render, staticRenderFns } from "./ProductOrderForm.vue?vue&type=template&id=6d25316d&scoped=true"
import script from "./ProductOrderForm.vue?vue&type=script&lang=ts"
export * from "./ProductOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./ProductOrderForm.vue?vue&type=style&index=0&id=6d25316d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25316d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d25316d')) {
      api.createRecord('6d25316d', component.options)
    } else {
      api.reload('6d25316d', component.options)
    }
    module.hot.accept("./ProductOrderForm.vue?vue&type=template&id=6d25316d&scoped=true", function () {
      api.rerender('6d25316d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/give-away/components/ProductOrderForm.vue"
export default component.exports